import { Outlet } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Header from "./pages/Header";
import { InterviewProvider } from "./services/InterviewProgressContext";

const Layout = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <InterviewProvider>
        <Header />
        <Outlet />
      </InterviewProvider>
    </DndProvider>
  );
};

export default Layout;
